import { Injectable } from "@angular/core";
import { ApiService } from "./api.service";
import { map } from "rxjs/operators";

@Injectable()
export class CustomersService {
  constructor(private apiService: ApiService) {}

  getAll(query = "") {
    return this.apiService.get(`/customers${query}`);
  }

  get(id) {
    return this.apiService
      .get(`/customers/${id}`)
      .pipe(map((result: any) => result.data));
  }

  search(keyword) {
    return this.apiService
      .post(`/customers/search`, {
        keyword
      })
      .pipe(map((result: any) => result.data));
  }

  create(customer) {
    if (customer && customer.insurance_date && customer.insurance == 1) {
      const insuranceDate = new Date(customer.insurance_date);
      customer.insurance_date = `${insuranceDate.getMonth() +
        1}/${insuranceDate.getDate()}/${insuranceDate.getFullYear()}`;
    } else {
      customer.insurance_date = null;
    }
    return this.apiService.upload(`/customers`, customer);
  }

  update(id, customer) {
    if (customer && customer.insurance_date && customer.insurance == 1) {
      const insuranceDate = new Date(customer.insurance_date);
      customer.insurance_date = `${insuranceDate.getMonth() +
        1}/${insuranceDate.getDate()}/${insuranceDate.getFullYear()}`;
    } else {
      customer.insurance_date = null;
    }
    console.log("=>", customer);
    return this.apiService.upload(`/customers/${id}`, customer);
  }

  destroy(id) {
    return this.apiService.delete(`/customers/${id}`);
  }

  getCustomerStatics(id) {
    return this.apiService.get(`/statistics/user/${id}`);
  }

  getAllCustomers() {
    return this.apiService.get(`/getallcustomers`);
  }

  getCustomersForInsurance() {
    return this.apiService.get("/getcustomersforinsurance");
  }
}
